export default {
    sticky: {
        closeOnClick: false,
        autoClose: false
    },
    alert: {
    },
    error: {
        icon: 'attention-circle',
        color: 'red',
        animation: 'bounce'
    },
    wrong: {
        icon: 'attention-circle',
        accent: 'red',
        color: 'inverse',
        animation: 'bounce'
    },
    failed: {
        icon: 'cancel-circled',
        accent: 'red',
        color: 'inverse',
    },
    success: {
        icon: 'check_circle',
        accent: 'green'
    },
    info: {
        icon: 'info-circled',
        accent: 'blue'
    },
    warning: {
        icon: 'attention-1',
        color: 'orange'
    }
}